/* eslint-disable unicorn/filename-case */

angular.module('app.LawyerProfile').directive('employmentForm', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      formName: '@',
      candidate: '=',
      submitHandler: '&',
      cancelHandler: '&',
      employment: '=',
      employers: '=',
      locations: '=',
      practices: '=',
      occupations: '=',
      contracts: '=',
    },
    template: require('./employment-form.html'),
    controller: employmentFormCtrl,
  }
})

function employmentFormCtrl($scope, $uibModal, sharedProperties) {
  $scope.isAdminSession = sharedProperties.isAdminSession()

  $scope.today = new Date()

  $scope.salaryDetailsDatePickerOptions = {
    'datepicker-mode': "'day'",
    'year-format': "'yy'",
    'starting-day': 1,
    defaultDate: '1',
  }

  $scope.employmentFormDatePickerOptions = {
    'year-format': "'yy'",
    'starting-day': 1,
    'datepicker-mode': "'month'",
    'min-mode': 'month',
    defaultDate: '1',
  }

  // $scope.currencyList = cc.codes();

  $scope.verifyEmployerNameEscapeChar = string => {
    if (string === void 0) {
      $scope.employment.employer.name = ''
    } else {
      $scope.employment.employer.name = string.trim()
    }
  }

  $scope.openLocModal = () => {
    const modalInstance = $uibModal.open({
      templateUrl: 'locations-modal.html',
      controller: 'LocationsModalController',
      controllerAs: 'ctrl',
      resolve: {
        locationList: function() {
          return $scope.locations
        },
        selectedLocations: function() {
          return $scope.employment.location ? [$scope.employment.location] : []
        },
        limit: function() {
          return 1
        },
        locationModalHeading: function() {
          return true
        },
        displayNextButton: function() {
          return false
        },
      },
    })
    modalInstance.result.then(
      async selectedLocations => {
        $scope.employment.location = angular.copy(selectedLocations[0])
      },
      () => {}
    )
  }

  $scope.openPracticeAreasModal = () => {
    const candidatePractices = $scope.employment.specialties.map(
      candidatePractice =>
        $scope.practices.find(practice => practice.id === candidatePractice.id)
    )
    const modalInstance = $uibModal.open({
      templateUrl: 'practice-area-modal.html',
      controller: 'PracticeAreaController',
      controllerAs: 'ctrl',
      resolve: {
        practiceAreaList: function() {
          return $scope.practices.filter(({parentId}) => parentId === null)
        },
        selectedPractice: function() {
          return candidatePractices
        },
        limit: function() {
          return $scope.candidate.isAdminProfile ? 0 : 5
        },
        isAdminProfile: function() {
          return Boolean($scope.candidate.isAdminProfile)
        },
        displayNextButton: function() {
          return false
        },
      },
    })
    modalInstance.result.then(
      async selectPractices => {
        $scope.employment.specialties = angular.copy(selectPractices)
      },
      () => {}
    )
  }
}



// WEBPACK FOOTER //
// ./scripts/candidate-profile/employment-history/employmentForm.js